<template>
  <div class="settings-toggle-block">
    <div class="d-flex flex-row align-items-start">
      <div class="d-flex flex-column flex-fill">
        <slot name="title"><span class="d-block lead">{{ title }}</span></slot>
        <slot name="description"><span class="d-block">{{ description }}</span></slot>
      </div>
      <b-button @click="() => visible = !visible" size="sm" variant="outline">
        <template v-if="visible">Close</template>
        <template v-else>Expand</template>
      </b-button>
    </div>
    <transition name="fade">
      <slot v-if="visible"/>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => 'Title',
    },
    description: {
      type: String,
      default: () => 'Description!',
    },
  },
  data: () => ({
    visible: false,
  }),
};
</script>

<style lang="scss">
.settings-toggle-block {
  .lead {
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/ToggleBlock.vue